import React from 'react';
import { ApplicationShipmentAddress } from '@sdir/httpclient/lib/clients/aps/application';

const DisplayedShipmentAddress: React.FC<{
  shipmentAddress: ApplicationShipmentAddress;
}> = ({ shipmentAddress }) => {
  return (
    <>
      <div>{shipmentAddress?.name}</div>
      <div>{shipmentAddress?.address}</div>
      <div>{shipmentAddress?.address2}</div>
      <div>{`${shipmentAddress?.zip} ${shipmentAddress?.city}`}</div>
      <div>{shipmentAddress?.country}</div>
    </>
  );
};

export default DisplayedShipmentAddress;
